import React from 'react'

type Props = {
  className?: string
  color?: string
}

const ExternalLink: React.FC<Props> = ({ className, color = '#0073BF' }) => (
  <svg
    className={className}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1.66667 15C1.20833 15 0.815972 14.8368 0.489583 14.5104C0.163194 14.184 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H7.5V1.66667H1.66667V13.3333H13.3333V7.5H15V13.3333C15 13.7917 14.8368 14.184 14.5104 14.5104C14.184 14.8368 13.7917 15 13.3333 15H1.66667ZM5.58333 10.5833L4.41667 9.41667L12.1667 1.66667H9.16667V0H15V5.83333H13.3333V2.83333L5.58333 10.5833Z"
      fill={color}
    />
  </svg>
)

export default ExternalLink
